const listBeneficiariesTemplate = `
<div class="beneficiaries-wrap">
    <table class="beneficiaries {{designation}}-beneficiaries table">
        <thead>
        <tr>
            <th class="col-xs-5 col-sm-6">
                {{ inCustomEnrollment ? 'app.beneficiary.beneficiaryTable.headings.'+designation : 'app.beneficiary.beneficiaryTable.headings.name' | translate }}
            </th>
            <th class="col-xs-3 col-sm-4">{{ 'app.beneficiary.beneficiaryTable.headings.type' | translate }}</th>
            <th class="col-xs-4 col-sm-2">{{ 'app.beneficiary.beneficiaryTable.headings.allocation' | translate }}</th>
        </tr>
        </thead>
        <tbody>
            <tr ng-repeat="uiBeneficiary in beneficiaries" ng-class="(uiBeneficiary.beneficiary.saveErrors)?'beneficiary-error':'no-beneficiary-error'">
                <td class="beneficiary-name" ng-if="!uiBeneficiary.errored">
                    <a 
                       tabindex="0"
                       ng-click="model.editBeneficiary(uiBeneficiary.beneficiary);"
                       ng-keydown="model.handleKeyboardDownEvent($event, uiBeneficiary.beneficiary);"
                       ng-if="!inCustomEnrollment">
                        {{uiBeneficiary.beneficiary.name}}
                    </a>
                    <span ng-if="inCustomEnrollment">{{uiBeneficiary.beneficiary.name}}</span>
                </td>
                <td class="beneficiary-type" ng-if="!uiBeneficiary.errored">
                       <a 
                         tabindex="0"
                         ng-class="model.checkifValidFields(uiBeneficiary.beneficiary)?'error-block benefiacary-text':'beneficiary-type'" 
                         ng-click="model.editBeneficiary(uiBeneficiary.beneficiary);"
                         ng-keydown="model.handleKeyboardDownEvent($event, uiBeneficiary.beneficiary);"
                         ng-if="!inCustomEnrollment">
                       {{(model.checkifValidFields(uiBeneficiary.beneficiary) && model.isUpdateAllowed())?'Updates Required':model.getTypeOrRelationshipDisplay(uiBeneficiary.beneficiary.beneficiaryType);}}
                       </a>
                        <span ng-if="inCustomEnrollment">{{model.getTypeOrRelationshipDisplay(uiBeneficiary.beneficiary.beneficiaryType);}}</span>
                </td>
                <!-- <td class="beneficiary-type" ng-bind-html="model.getTypeOrRelationshipDisplay(beneficiary.beneficiaryType);"></td> -->
                <td class="beneficiary-allocation" ng-if="!uiBeneficiary.errored">
                    <span ng-if="inCustomEnrollment || (model.getBeneficiariesLength(beneficiaries) === 1 && uiBeneficiary.beneficiary.allocationPercent == 100)">
                        {{uiBeneficiary.beneficiary.allocationPercent}} %
                    </span>

                    <div ng-if="!inCustomEnrollment && (model.getBeneficiariesLength(beneficiaries) > 1 || uiBeneficiary.beneficiary.allocationPercent < 100)" class="col-md-8 row">
                        <div class="input-group input-group-sm input-group-percentage">
                          <input type="number"
                                 step="0.01"
                                 name="{{designation}}BeneficiaryAllocationPercent{{$index}}"
                                 id="{{designation}}BeneficiaryAllocationPercent{{$index}}"
                                 aria-label="Allocation for beneficiary {{uiBeneficiary.beneficiary.name}}"
                                 class="form-control"
                                 ng-model="uiBeneficiary.beneficiary.allocationPercent"
                                 two-decimal-number-validator
                                 ng-disabled="isViewOnly || qjsaVerificationRequired"
                                 ng-model-options="{ updateOn: 'default blur', allowInvalid: true }"
                                 ng-blur="allocationChanged();"
                                 required />
                          <span class="input-group-addon">%</span>
                        </div>
                    </div>
                </td>
                <td colspan="3" ng-if="uiBeneficiary.errored">
                    <div aria-live="polite" ng-if="uiBeneficiary.saveErrors.length > 0" class="error-block">
                        <ul class="list-unstyled">
                            <li ng-repeat="error in uiBeneficiary.saveErrors">{{error}}</li>
                        </ul>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
`;
export default listBeneficiariesTemplate;